/** Chart.js dataset colors (aligned with roster statistics charts). */
export const DASHBOARD_CHART_LINE = {
  borderColor: 'rgba(130, 190, 255, 0.95)',
  backgroundColor: 'rgba(130, 190, 255, 0.15)',
};

/** Horizontal bar sizing (dashboard events-by-name bars). */
export const DASHBOARD_EVENTS_BAR_THICKNESS = 15;
export const DASHBOARD_EVENTS_BAR_GAP = 8;

export const dashboardLineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: { display: true, text: 'Count' },
      ticks: { precision: 0 },
    },
    x: {
      title: { display: true, text: 'Month' },
    },
  },
};

